module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Blue_TW.22c77e9d.png";